module.exports = __webpack_public_path__ + "static/media/IconNotice.88fd862c.svg";